module.exports = __webpack_public_path__ + "components/page-header/static/mountain-forecast__logo--clear-1222183958792ea6def66a2bd0b35991.png";